jQuery(document).ready(function ($) {
  $(".posts-list.organizers").each(function () {
    const
      // MISC
      priorizedOrganizerNames = [
        'Omkára',
        'Ánandí'
      ],

      // DOM
      $organizersList = $(this),
      $priorizedOrganizer = priorizedOrganizerNames.map(name => {
        return $organizersList.find(`article:contains('${name}')`);
      });

    console.log($priorizedOrganizer);

    $priorizedOrganizer.reverse().forEach($organizer => {
      $organizersList.prepend($organizer.detach());
    });
  });
});
